// apps/vendor/src/lib/i18n/I18nProvider.tsx
//
// Phase 7 Wave 18 Task 76 (Amendment #1) — wraps the vendor SPA in
// <I18nextProvider>. Also reconciles the active locale with the
// authenticated user's `user.language` field (vendor uses `useAuth` from
// `@printway/ui`, not a portal-local store): when a profile PATCH in
// another tab changes the language and we re-hydrate, the SPA flips locale
// without a manual reload. When the user is anonymous, the LanguageDetector
// cookie+localStorage chain takes over.
//
// vg-binding: PLAN:task-76
// vg-binding: P7.D-134
// vg-binding: P7.D-152
// vg-binding: AMENDMENT-1

import { useEffect, type ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { useAuth } from '@printway/ui';

import { i18n, userLangToLocale } from './index.js';

interface I18nProviderProps {
  children: ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps): JSX.Element {
  const userLanguage = useAuth((s) => s.user?.language ?? null);

  useEffect(() => {
    if (!userLanguage) return;
    const target = userLangToLocale(userLanguage);
    if (i18n.language !== target) {
      void i18n.changeLanguage(target);
    }
  }, [userLanguage]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

export default I18nProvider;
